module.exports = __webpack_public_path__ + "img/google-store-logo.e71e5bbd.svg";